import React from 'react';
import { Modal, Spin } from 'antd';
import { Login } from '../login/login.component';
import './loginModal.scss';

export const LoginModal = ({ title, open, onCancel, onLoginSuccess, redirectPath, flow, showSignup=true, currentStepKey, isLoading }) => {


    return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      className="login-modal"
      destroyOnClose
    >

      {isLoading ? 
        <div className="loading-container" style={{minHeight: '400px'}}> <Spin size="large" /><p>One Moment Please</p></div> : 
        
        <Login 
            isModal 
            redirectPath={redirectPath || window.location.pathname}
            onLoginSuccess={onLoginSuccess}
            title={title || 'First, let\'s login to your account'}
            flow={flow}
            showSignup={showSignup}
            currentStepKey={currentStepKey}
            isLoading={isLoading}
          />
      }

    </Modal>
  );
}; 